export default __webpack_public_path__ + "static/media/IL.927acd20.svg";